import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import RenderLoading from '../RenderLoading/RenderLoading';
import {checkstate} from '../../components/service/service.supersalud';
import { isAuthenticate } from '../commons/utils';
import jwt_decode from 'jwt-decode';

 
const LoginClaveUnica = (props) => {
    let location = useLocation();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const { user, userLoggedIn } = props;
  
    //console.log("aqui16", props)
   


    const getState = async (state,code) => {

        try {
            setLoading(true);
            var raw = JSON.stringify({"state":state,"code":code});

            const resp = await checkstate()(raw)
            const resp_status = await resp.status;
            
             setLoading(false);
            if (resp_status === 200) {
               
                const data = await resp.json();

                let decoded = jwt_decode(data.token)

                let aux=decoded.sub
                var obj = aux.replace(/'/g,"\""); //Permite reemplazar ' por "
                let rutAux = JSON.parse(obj)
                let auxUser =  {
                    ...data,
                    rut: rutAux.run + "-" + rutAux.dv
                }
                //console.log("aqui43", props)
                userLoggedIn(auxUser);
                return history.push("/MediacionAseguradora");
            }else{
                return history.push("/login?claveunicaMessage=true"); 
            } 

           
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        var searchParams = new URLSearchParams(location.search);
        const code = searchParams.get("code");
        const state = searchParams.get("state");
        if (!user && state && code){
            getState(state,code);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user,location])

    useEffect(()=>{
        if(isAuthenticate(user)){
            return history.push("/MediacionAseguradora");
        }else{
            return history.push("/login?claveunicaMessage=true"); 
        }
    },[])

    return (
        <div>
            {
                loading?<RenderLoading/>:null
            }
        </div>
    )
}

export default LoginClaveUnica;
